import React from "react";
import { StatusReservaEnum } from "core/features/reservas/typings";
import colors from "resources/theme/colors";
import { Tag } from "@chakra-ui/react";

interface FiltroTipoStatusProps {
  selectedTipoStatus?: string;
  setSelectedTipoStatus?: (id?: string) => any;
}

function TagStatus({
  onClick,
  selected,
  children,
}: {
  onClick: () => any;
  selected: boolean;
  children: React.ReactNode;
}) {
  return (
    <Tag
      bg={selected ? colors.blue500 : colors.lightGray}
      color={selected ? colors.white : colors.black}
      borderRadius={20}
      mr={2}
      mb={2}
      p={2}
      _hover={{
        background: `${colors.blue500}`,
        color: `${colors.white}`,
      }}
      transition="all 0.3s"
      onClick={onClick}
      cursor="pointer"
      fontWeight="normal"
    >
      {children}
    </Tag>
  );
}

function FiltroTagStatusReserva({
  selectedTipoStatus,
  setSelectedTipoStatus,
}: FiltroTipoStatusProps) {
  const onSelectTipoStatus = (t: string) => {
    if (selectedTipoStatus === t) {
      setSelectedTipoStatus?.(undefined);
    } else {
      setSelectedTipoStatus?.(t);
    }
  };

  const items = StatusReservaEnum;

  return (
    <>
      <TagStatus
        onClick={() => onSelectTipoStatus?.("")}
        selected={selectedTipoStatus === ""}
      >
        Todos
      </TagStatus>
      {(Object.keys(items) as (keyof typeof items)[]).map((key) => (
        <TagStatus
          onClick={() => onSelectTipoStatus?.(items[key])}
          selected={selectedTipoStatus === items[key]}
        >
          {getTextForKey(key)}
        </TagStatus>
      ))}
    </>
  );
}

const getTextForKey = (key: keyof typeof StatusReservaEnum) => {
  switch (key) {
    case "AguardandoPagamento":
      return "Aguardando Pagamento";
    default:
      return key;
  }
};
export default FiltroTagStatusReserva;
